import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ConstantsRotasDoSistema } from 'src/app/shared/constants/constants-rotas-do-sistema';
import { ApresentacaoSistemaComponent } from './apresentacao-sistema.component';
import { AuthGuardService } from 'src/app/shared/services/auth.service';

const routes: Routes = [
    {
        path: ConstantsRotasDoSistema.APRESENTACAO,
        component: ApresentacaoSistemaComponent,
        canActivate: [AuthGuardService]
    }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ApresentacaoSistemaRoutingModule { }
